import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { useLocation } from "react-router";

import Title from "@/shared/components/Title/Title";
import ReverseButton from "@/shared/components/ReverseButton/ReverseButton";

import { resetPatientsData } from "@/store/patients/patients";

import "./PatientDetailsPageHeader.scss";

export default function PatientDetailsPageHeader() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const patientInfo = useSelector(
        (state: RootState) => state.patients.selectedPatient,
    );
    const userInfo = useSelector(
        (state: RootState) => state.users.selectedDoctor,
    );
    const isPatientpage = location.pathname.includes("patients");

    return (
        <header className='header_in_content_component header_in_patiens_page'>
            <ReverseButton
                onClick={() => {
                    dispatch(resetPatientsData());
                    navigate(-1);
                }}
            />
            <img
                className='patient_details_page_header_img'
                src='/patientdetailspage/tooth icon.svg'
                alt='tooth icon'
            />
            <Title
                tag='h2'
                text={
                    isPatientpage
                        ? patientInfo?.name
                            ? patientInfo.name
                            : ""
                        : userInfo?.name
                        ? userInfo.name
                        : ""
                }
            />
        </header>
    );
}
